// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"841ab762","434":"ec61df4b","671":"43d5be95"}[chunkId] + ".chunk.css";
};